
// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/analytics';

import { firebaseConfig } from '../config/env';


firebase.initializeApp(firebaseConfig.config);
firebase.analytics();

export const firestoreRef = firebase.firestore();
export const storageRef = firebase.storage();
